import { Group, Marquee, Stack, Text2 } from '@el8/vital';
import React from 'react';
import { TextareaFormik } from '@el8/vital-formik';
import { useFormikContext } from 'formik';
import { Persona } from '@elation/api-client/src/support';

import UrgentCase from './UrgentCase';
import styles from './DefaultIntakeInfo.less';
import NextStepButton from './NextStepButton';
import { CaseIntakeInfoProps } from '../CaseIntakeTypes';
import { CaseIntakeFormValues } from '../CaseIntakeForm';

const DefaultIntakeInfo: React.FC<CaseIntakeInfoProps> = ({ isLoading, onNext }) => {
  const { values } = useFormikContext<CaseIntakeFormValues>();

  return (
    <>
      <Stack gap="xs">
        <UrgentCase />
        {values.persona === Persona.passport_user && (
          <Marquee
            intent="neutral"
            title="This page is for Elation Passport technical support."
            data-testid="support-intake-passport-user-notice"
          >
            Use this form only for technical issues with Elation Passport, such as trouble logging
            in or accessing the site. For medical questions or care-related concerns, please contact
            your doctor&apos;s office directly.
          </Marquee>
        )}
        <Text2>
          Tell us what help you need help with. If something isn&apos;t working, share the details
          of what&apos;s wrong and where the issue is located, any error messages, and the steps you
          took.
        </Text2>
        <div className={styles.inputContainer}>
          <TextareaFormik
            label="Details"
            labelPosition="column"
            data-testid="support-intake-form-details"
            name="details"
            required
            rows={5}
          />
          {values.persona === Persona.ehr_user && (
            <Text2 appearance="muted" sizing="sm">
              Do not include the patient&apos;s name or other PHI in this form.
            </Text2>
          )}
        </div>
      </Stack>
      <Group>
        <NextStepButton isLoading={isLoading} onNext={onNext} />
      </Group>
    </>
  );
};

export default DefaultIntakeInfo;
